<template>
    <div>
        <div class=" reveal">
            <div class="pa-5">
                <v-card
                        class="mx-auto rounded-xl pb-4 pr-4"
                        elevation="0"
                        min-height="200"
                        style="max-width: 800px"
                >

                    <v-list-item three-line class="pa-2">
                        <v-list-item-avatar
                                tile
                                size="100"
                                color="grey"
                                class="ml-5 rounded-lg"

                        >
                            <img src="../../../../assets/review-csp.png" alt="AP CSP Review"/>

                        </v-list-item-avatar>

                        <v-list-item-content class="pl-4 text-center">
                            <div class="font-weight-bold mt-3 mb-5"
                                 style="font-size: 20px; margin-bottom: 9px !important; font-family: S-CoreDream-5Medium">
                                AP CSP 프로젝트 잘 끝냈어요!
                                <!--                                <v-chip class="mt-2" small-->
                                <!--                                        style="font-weight: normal !important; font-size: 12px !important; background: #cb2d3e; background: linear-gradient(to bottom, #ef473a, #cb2d3e); color: #fafafa;">-->
                                <!--                                    입시정보-->
                                <!--                                </v-chip>-->

                            </div>
                            <!--                            <img style="width: 100%" src="https://i.postimg.cc/FRd4Hknq/review1.webp"/>-->


                            <!--                            <v-expansion-panels style="font-size: 17px;margin-left: -22px !important; margin-top: -10px !important;" flat>-->
                            <!--                                <v-expansion-panel >-->
                            <!--                                    <v-expansion-panel-header>-->
                            <!--                                        학교 선생님 수업 설명이 너무 부족해서 시작하게 됐어요. 동안 너무 힘들었는데..-->
                            <!--                                    </v-expansion-panel-header>-->
                            <!--                                    <v-expansion-panel-content>-->
                            <!--                                        학교 선생님 수업 설명이 너무 부족해서 시작하게 됐어요. 동안 너무 힘들었는데, 과외수업을 듣고 시작하고 난 뒤 부터 드디어 Java에 대해 이해하기 시작하고 퀴즈도 만점 받고 있어요. 수업시간 외에도 질문에 언제나 답해주시고 추가 관리까지 해주셔서 감사해요.-->
                            <!--                                    </v-expansion-panel-content>-->
                            <!--                                </v-expansion-panel>-->
                            <!--                            </v-expansion-panels>-->

                        </v-list-item-content>

                    </v-list-item>
                    <div class="pl-8 pb-5">
                        <div style="font-size: 15px; z-index: 2; font-family: S-CoreDream-4Regular">
                            11학년 | AP Computer Science Principles
                        </div>
                        <div class="py-2"></div>
                        <div style="font-size: 14px; z-index: 2; font-family: S-CoreDream-4Regular">
                            Create Performance Task 준비 어떻게 해야할지 너무 막막해서 과외 시작하게 되었어요. 학교 수업에서 코딩을 안 배워서 너무 걱정됐는데, 과외쌤한테
                            하나하나 배우면서 프로젝트 완성했어요. 진짜 지금 생각하면 아찔해요. 도움 주셔서 너무 감사합니다.
                        </div>
                    </div>
                </v-card>
            </div>

        </div>

    </div>
</template>

<script>
    export default {
        name: "ReviewPage6",
        mounted() {
            window.addEventListener("scroll", this.reveal);
        },
        destroyed() {
            window.removeEventListener("scroll", this.reveal);
        },
        methods: {
            reveal() {
                var reveals = document.querySelectorAll(".reveal");

                for (var i = 0; i < reveals.length; i++) {
                    var windowHeight = window.innerHeight;
                    var elementTop = reveals[i].getBoundingClientRect().top;
                    var elementVisible = 150;

                    if (elementTop < windowHeight - elementVisible) {
                        reveals[i].classList.add("active");
                    } else {
                        reveals[i].classList.remove("active");
                    }
                }
            },
        },
    };
</script>

<style>

    body {
        /*background: #42455a;*/
    }

    section {
        /*min-height: 100vh;*/
        /*display: flex;*/
        /*justify-content: center;*/
        /*align-items: center;*/
    }

    .each-title {
        font-size: 21px !important;
        text-align: left !important;
    }

    section:nth-child(1) {
        color: black;
    }

    section:nth-child(2) {
        color: black;
        background: #ffffff !important;
    }

    /* Add more styles for other sections as needed */
    section .container {
        /*margin: 100px;*/
        background-color: #ffffff !important;

    }

    section h1 {
        /*font-size: 3rem;*/
        /*margin: 20px;*/
    }

    section h2 {
        font-size: 40px;
        /*text-align: center;*/
        text-transform: uppercase;
    }

    section .text-container {
        display: flex;
        padding: 20px;
        margin-top: 10px;
    }

    section .text-container .text-box {
        /*margin: 20px;*/
        /*padding: 20px;*/
        /*background: #00c2cb;*/

    }

    section .text-container .text-box h3 {
        font-size: 30px;
        /*text-align: center;*/
        text-transform: uppercase;
        margin-bottom: 10px;
    }

    @media (max-width: 900px) {
        section h1 {
            font-size: 2rem;
            /*text-align: center;*/
        }

        section .text-container {
            flex-direction: column;
        }
    }

    .reveal {
        position: relative;
        transform: translateY(150px);
        opacity: 0;
        transition: 1s all ease;
    }

    .reveal.active {
        transform: translateY(0);
        opacity: 1;
    }
</style>

